import { render, staticRenderFns } from "./General.vue?vue&type=template&id=09b7b65b&lang=pug"
import script from "./General.vue?vue&type=script&lang=js"
export * from "./General.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports